<template>
  <div id="login">
    <section class="login-card">
      <img src="../assets/brand/buiran.svg" class="login-brand" alt="Buiran" />
      <h1>Gestiona tu carta</h1><p>Accede para organizar tus platos y menús.</p>
      <el-form label-position="top" @submit.native.prevent="accessUser('click')">
        <el-form-item label="Usuario" for="login-user"><el-input id="login-user" placeholder="Usuario" v-model="usuario" autocomplete="username" clearable /></el-form-item>
        <el-form-item label="Contraseña" for="login-password"><el-input id="login-password" placeholder="Contraseña" v-model="contraseña" autocomplete="current-password" show-password /></el-form-item>
        <el-button type="primary" native-type="submit">Entrar</el-button>
      </el-form>
    </section>
    <el-dialog title="No se pudo iniciar sesión" :visible.sync="dialog" append-to-body><p>Revisa el usuario y la contraseña e inténtalo de nuevo.</p></el-dialog>
  </div>
</template>
<script>
import * as api from "../api/request.js";
import storage from "../api/storage.js";
export default {
  mounted() {
    if (storage.loadAuthenticated() === "true") {
      this.$router.replace("/Home");
    }
  },
  data() {
    return {
      usuario: "",
      contraseña: "",
      logo: "",
      dialog: false,
    };
  },
  methods: {
    accessUser: async function (event) {
      if (event === "click" || event.which === 13) {
        try {
          let login = await api.login(this.usuario, this.contraseña);
          if (login.status == 200) {
            storage.saveToken(
              login.data.logo,
              this.logo,
              login.data.name,
              login.data.nameRestaurant,
              login.data.token,
              login.data.url
            );
            storage.saveAuthenticated(true);
            this.$emit("authenticated", true);
            this.$router.replace("/Home");
          }
        } catch (error) {
          this.dialog = true;
        }
      }
    },
  },
};
</script>
<style scoped>
#login { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; }
.login-card { width: 100%; max-width: 420px; padding: 32px; background: white; border: 1px solid #dce4e3; border-radius: 18px; box-shadow: 0 12px 40px #2739410a; }
.login-brand { display: block; width: 68px; height: 60px; object-fit: contain; margin-bottom: 24px; }
.login-card h1 { font-size: 28px; margin: 0 0 8px; }
.login-card p { color: #687780; font-size: 14px; line-height: 1.6; margin-bottom: 28px; }
.login-card .el-button { width: 100%; }
</style>